/* ==========================================================================
   Millennio — Tamaño en las filas del buscador (#98b, 3-nov-2026)
   --------------------------------------------------------------------------
   Pedido del cliente (Juan, vía Bryan): desde el buscador la bolsa debe añadir
   al carrito sin ir a la ficha, y el tamaño se elige EN LA FILA, con un
   desplegable debajo del precio — no con el cajón inferior de variantes.

   CÓMO
   - Cada fila de producto ('[data-mi-fila]', tanto las iniciales en Liquid
     como las que pinta mi-search.js) recibe un desplegable con sus
     presentaciones, leídas de '/products/<handle>.js' (una petición por
     producto, cacheada en la sesión). Con una sola presentación disponible no
     se pinta nada: no hay qué elegir.
   - #98c (3-nov): el desplegable es PROPIO, no un <select>. La lista nativa
     de Chrome en Mac sale translúcida sobre el buscador y costaba leer
     tamaños y precios (captura de Bryan). Esta lista es blanca y opaca, con
     el tamaño a la izquierda y el precio a la derecha, y se abre hacia arriba
     si abajo no cabe.
   - Por defecto queda elegida la primera presentación disponible: la misma
     que muestra el precio de la fila y la que la ficha vende por defecto.
   - Al cambiar el tamaño se actualiza el precio (y el tachado, solo si ESA
     variante tiene precio anterior: prohibido inventar rebajas).
   - La bolsa añade la presentación elegida con 'miCarrito.anadirVariante'
     (mi-product-card.js). Este guion intercepta el clic en CAPTURA, antes que
     mi-search.js, así su cajón de variantes ya no se abre desde el buscador.
   - Si los datos no llegan, la bolsa lleva a la ficha (nunca sin salida).
   - #98d (3-nov): añadir NO cierra el buscador ni abre el carrito: el
     cliente sigue buscando y añadiendo. La bolsa se marca con un check y
     abajo del buscador aparece «Añadido al carrito … · Ver carrito». El
     carrito (ya actualizado por debajo) se abre cuando el buscador se cierra.
     Se logra envolviendo 'ajaxCart.load' del tema: mientras el buscador
     está abierto se llama con 'abrir = false'.
   - #98e (3-nov): RESULTADOS LITERALES. La búsqueda predictiva de Shopify
     mezcla productos «parecidos» que no contienen lo escrito (medido:
     «euphoria» o «eu» traían CK One, IN2U, Eternity y CK Be; «sauvage» traía
     Miss Dior y Dior Homme), mientras la página de resultados solo trae los
     2 Euphoria. Reporte de Juan: «literal en el buscador». Se filtra la
     respuesta de '/search/suggest.json': quedan solo los productos en cuyo
     título, marca, tipo o presentaciones TODAS las palabras escritas son el
     comienzo de alguna palabra (sin tildes ni mayúsculas; «eu» → Euphoria). Si ninguno las contiene
     (p. ej. un error de tipeo como «lataffa»), se dejan los de Shopify, que
     sí corrige errores. Se piden 10 y se muestran los que pedía el buscador.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__miTallasBuscador) { return; }
  window.__miTallasBuscador = true;

  var raiz = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  /* ---- Resultados literales (#98e) --------------------------------------- */
  function normal(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  /* Cada palabra escrita debe ser el COMIENZO de alguna palabra del título,
     la marca, el tipo o las presentaciones (los mismos campos que el buscador
     pide a Shopify). Comienzo y no «contiene»: «ck one» no debe traer
     «One Million BLACK». Las etiquetas no cuentan: una etiqueta mal escrita
     («Lataffa») dejaba un solo resultado en vez de corregir el tipeo. */
  function contieneTodo(prod, palabras) {
    var pajar = ' ' + normal([
      prod.title, prod.vendor, prod.type,
      (prod.variants || []).map(function (v) { return v && v.title; }).join(' ')
    ].join(' ')).replace(/[^a-z0-9]+/g, ' ');
    for (var i = 0; i < palabras.length; i++) {
      if (pajar.indexOf(' ' + palabras[i]) === -1) { return false; }
    }
    return true;
  }
  (function () {
    var fetchOriginal = window.fetch;
    if (!fetchOriginal || fetchOriginal.__miLiteral) { return; }
    /* #98f — UNA sola petición por producto. mi-search.js (precio de la
       primera presentación) y este guion (tamaños) pedían cada uno
       '/products/<handle>.js': 12 peticiones para 6 filas. Se comparte la
       misma respuesta durante la sesión. */
    var memo = {};
    function productoJs(url, opciones) {
      if (opciones && opciones.method && String(opciones.method).toUpperCase() !== 'GET') { return null; }
      var ruta;
      try { ruta = new URL(url, window.location.origin).pathname; } catch (e) { return null; }
      if (!/\/products\/[^\/]+\.js$/.test(ruta)) { return null; }
      if (!memo[ruta]) {
        memo[ruta] = fetchOriginal.call(window, ruta, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, status: r.status, texto: t }; }); })
          .catch(function (e) { delete memo[ruta]; throw e; });
      }
      return memo[ruta].then(function (c) {
        if (!c.ok) { delete memo[ruta]; }
        return new Response(c.texto, { status: c.status, headers: { 'Content-Type': 'application/json' } });
      });
    }
    window.__miPrecargarProducto = function (handle) {
      if (handle) { var x = productoJs(raiz + 'products/' + handle + '.js'); if (x) { x.catch(function () {}); } }
    };
    var envuelto = function (entrada, opciones) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var compartida = url.indexOf('.js') !== -1 && url.indexOf('/products/') !== -1 ? productoJs(url, opciones) : null;
      if (compartida) { return compartida; }
      if (url.indexOf('/search/suggest.json') === -1) { return fetchOriginal.apply(this, arguments); }
      var u, q, limite;
      try {
        u = new URL(url, window.location.origin);
        q = u.searchParams.get('q') || '';
        limite = parseInt(u.searchParams.get('resources[limit]'), 10) || 6;
        if (limite < 10) { u.searchParams.set('resources[limit]', '10'); }
      } catch (e) { return fetchOriginal.apply(this, arguments); }
      var palabras = normal(q).replace(/[^a-z0-9]+/g, ' ').split(' ').filter(function (w) { return w.length > 0; });
      return fetchOriginal.call(this, u.toString(), opciones).then(function (resp) {
        if (!resp || !resp.ok || !palabras.length) { return resp; }
        return resp.clone().json().then(function (d) {
          var r = d && d.resources && d.resources.results;
          if (r && r.products && r.products.length) {
            var literales = r.products.filter(function (p) { return contieneTodo(p, palabras); });
            r.products = (literales.length ? literales : r.products).slice(0, limite);
            // Precarga de presentaciones: arranca antes de que se pinten las filas.
            r.products.forEach(function (p) { window.__miPrecargarProducto(p.handle); });
          }
          return new Response(JSON.stringify(d), { status: resp.status, statusText: resp.statusText, headers: { 'Content-Type': 'application/json' } });
        }).catch(function () { return resp; });
      });
    };
    envuelto.__miLiteral = true;
    window.fetch = envuelto;
  })();
  var cache = {};
  var abierto = null; // el .mi-buscador__tallas con la lista desplegada

  function datosDe(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(raiz + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function dinero(n) {
    var v = Math.round(Number(n) || 0);
    return '$' + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* Mismo criterio de nombres que mi-search.js: «Muestra 5 ml», no
     «5 ml (Muestra)»; «Default Title» no se enseña. */
  function nombre(v) {
    var t = (v.title || '').trim();
    var n = t.toLowerCase();
    if (n === 'default title') { return 'Presentación única'; }
    if (/muestra|decant/.test(n) || /^(5|10)ml$/.test(n.replace(/\s/g, ''))) {
      return 'Muestra ' + n.replace(/\(muestra\)|muestra|decant/g, '').replace(/\s+/g, ' ').trim();
    }
    return t;
  }

  function estilos() {
    if (document.getElementById('mi-tallas-buscador-css')) { return; }
    var s = document.createElement('style');
    s.id = 'mi-tallas-buscador-css';
    var B = '#mi-buscador .mi-buscador__tallas';
    s.textContent =
      B + '{grid-column:2;grid-row:3;position:relative;z-index:2;margin-top:6px;max-width:240px;}' +
      B + '.esta-abierta{z-index:40;}' +
      /* Reseteo de botón: el tema impone min-width, float, fondo y un ::before a todo <button>. */
      B + ' button{float:none;min-width:0;min-height:0;margin:0;box-shadow:none;text-transform:none;letter-spacing:0;' +
      'font-family:Inter,Arial,sans-serif;border-radius:0;cursor:pointer;-webkit-tap-highlight-color:transparent;}' +
      B + ' button::before,' + B + ' button::after{content:none !important;display:none !important;}' +
      B + ' .mi-tallas__boton{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;height:34px;' +
      'padding:0 10px;border:1px solid rgba(36,42,50,.28);background:#fff;color:#242a32;font-size:12.5px;font-weight:500;text-align:left;}' +
      B + ' .mi-tallas__boton:not(:disabled):hover{border-color:#242a32;}' +
      B + ' .mi-tallas__boton:disabled{cursor:default;opacity:1;}' +
      B + ' .mi-tallas__boton.esta-pendiente{color:#9aa0a8;border-color:rgba(36,42,50,.16);}' +
      B + ' .mi-tallas__boton.es-unica{border-color:rgba(36,42,50,.14);background:#f6f7f8;}' +
      B + ' .mi-tallas__boton.es-unica svg{display:none;}' +
      B + ' .mi-tallas__actual{flex:1 1 auto;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      B + ' .mi-tallas__boton:focus-visible{outline:2px solid #242a32;outline-offset:1px;}' +
      B + ' .mi-tallas__boton svg{flex:0 0 auto;width:10px;height:7px;transition:transform .18s ease;}' +
      B + '.esta-abierta .mi-tallas__boton{border-color:#242a32;}' +
      B + '.esta-abierta .mi-tallas__boton svg{transform:rotate(180deg);}' +
      B + ' .mi-tallas__lista{position:absolute;left:0;right:0;top:calc(100% + 4px);min-width:220px;margin:0;padding:4px 0;list-style:none;' +
      'background:#fff;border:1px solid rgba(36,42,50,.22);box-shadow:0 10px 28px rgba(0,0,0,.18);opacity:1;}' +
      B + ' .mi-tallas__lista[hidden]{display:none;}' +
      B + '.hacia-arriba .mi-tallas__lista{top:auto;bottom:calc(100% + 4px);}' +
      B + ' .mi-tallas__lista li{margin:0;padding:0;list-style:none;}' +
      B + ' .mi-tallas__op{display:flex;align-items:center;gap:8px;width:100%;min-height:42px;padding:8px 12px;border:0;' +
      'background:#fff;color:#242a32;font-size:13.5px;line-height:1.25;text-align:left;}' +
      B + ' .mi-tallas__op:hover,' + B + ' .mi-tallas__op:focus-visible{background:#f1f2f4;outline:none;}' +
      B + ' .mi-tallas__op[aria-selected="true"]{background:#242a32;color:#fff;}' +
      B + ' .mi-tallas__op[aria-selected="true"] .mi-tallas__precio{color:#fff;}' +
      B + ' .mi-tallas__op:disabled{cursor:default;color:#9aa0a8;background:#fff;}' +
      B + ' .mi-tallas__nombre{flex:1 1 auto;font-weight:500;}' +
      B + ' .mi-tallas__precio{flex:0 0 auto;font-weight:700;color:#242a32;white-space:nowrap;}' +
      B + ' .mi-tallas__op:disabled .mi-tallas__precio{font-weight:500;color:#9aa0a8;}' +
      B + ' .mi-tallas__check{flex:0 0 14px;width:14px;height:14px;visibility:hidden;}' +
      B + ' .mi-tallas__op[aria-selected="true"] .mi-tallas__check{visibility:visible;}' +
      /* Bolsa recién usada: check en vez de bolsa durante un momento. */
      '#mi-buscador .mi-buscador__anadir{position:relative;}' +
      '#mi-buscador .mi-buscador__anadir .mi-tallas__ok{position:absolute;inset:0;margin:auto;width:18px;height:18px;display:none;color:#1f7a3d;}' +
      '#mi-buscador .mi-buscador__anadir.mi-anadido .mi-tallas__ok{display:block;}' +
      '#mi-buscador .mi-buscador__anadir.mi-anadido i{visibility:hidden;}' +
      '#mi-buscador .mi-buscador__anadir.mi-anadido{border-color:#1f7a3d;}' +
      /* Aviso fijo abajo del buscador mientras haya algo añadido en esta búsqueda. */
      '#mi-buscador .mi-tallas-aviso{position:absolute;left:16px;right:16px;bottom:16px;z-index:60;display:flex;align-items:center;gap:10px;' +
      'padding:10px 10px 10px 14px;background:#242a32;color:#fff;box-shadow:0 10px 28px rgba(0,0,0,.25);font-family:Inter,Arial,sans-serif;' +
      'transform:translateY(12px);opacity:0;transition:opacity .2s ease,transform .2s ease;pointer-events:none;}' +
      '#mi-buscador .mi-tallas-aviso.esta-visible{transform:none;opacity:1;pointer-events:auto;}' +
      '#mi-buscador .mi-tallas-aviso svg{flex:0 0 18px;width:18px;height:18px;color:#7fd39a;}' +
      '#mi-buscador .mi-tallas-aviso__texto{flex:1 1 auto;min-width:0;font-size:12.5px;line-height:1.3;}' +
      '#mi-buscador .mi-tallas-aviso__texto strong{display:block;font-size:13px;font-weight:700;}' +
      '#mi-buscador .mi-tallas-aviso__texto span{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:.85;}' +
      '#mi-buscador .mi-tallas-aviso button{flex:0 0 auto;float:none;min-width:0;min-height:0;margin:0;height:36px;padding:0 14px;border:0;border-radius:0;' +
      'background:#fff;color:#242a32;font:700 12.5px/36px Inter,Arial,sans-serif;text-transform:none;letter-spacing:0;cursor:pointer;box-shadow:none;}' +
      '#mi-buscador .mi-tallas-aviso button::before,#mi-buscador .mi-tallas-aviso button::after{content:none !important;display:none !important;}' +
      '#mi-buscador .mi-buscador__panel.mi-con-aviso .mi-buscador__scroller{padding-bottom:84px;}' +
      /* El rótulo de presentación y «Muestras desde…» los dice ya el desplegable. */
      '#mi-buscador .mi-buscador__fila.tiene-tallas .mi-buscador__desde{display:none;}' +
      '#mi-buscador .mi-buscador__fila.tiene-tallas .mi-buscador__anadir{grid-row:2 / span 2;align-self:center;}';
    document.head.appendChild(s);
  }

  function precioEn(fila, v) {
    var caja = fila.querySelector('.mi-buscador__precio');
    if (!caja) { return; }
    var ahora = null;
    [].slice.call(caja.children).forEach(function (h) {
      if (!ahora && !h.className) { ahora = h; }
    });
    if (!ahora) { return; }
    ahora.textContent = dinero(v.price / 100);
    var viejo = caja.querySelector('.mi-buscador__antes');
    if (viejo) { viejo.remove(); }
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var t = document.createElement('span');
      t.className = 'mi-buscador__antes';
      t.textContent = dinero(v.compare_at_price / 100);
      caja.insertBefore(t, ahora);
    }
  }

  var SVG = 'http://www.w3.org/2000/svg';
  function icono(d, vb, cls) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', vb);
    s.setAttribute('aria-hidden', 'true');
    if (cls) { s.setAttribute('class', cls); }
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', d);
    p.setAttribute('fill', 'none');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.6');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }

  /* ---- Abrir / cerrar la lista ------------------------------------------ */
  function cerrarLista(devolverFoco) {
    if (!abierto) { return; }
    var caja = abierto;
    abierto = null;
    caja.classList.remove('esta-abierta', 'hacia-arriba');
    var lista = caja.querySelector('.mi-tallas__lista');
    var boton = caja.querySelector('.mi-tallas__boton');
    if (lista) { lista.hidden = true; }
    if (boton) {
      boton.setAttribute('aria-expanded', 'false');
      if (devolverFoco) { try { boton.focus({ preventScroll: true }); } catch (e) { boton.focus(); } }
    }
  }

  function abrirLista(caja) {
    if (abierto && abierto !== caja) { cerrarLista(false); }
    var lista = caja.querySelector('.mi-tallas__lista');
    var boton = caja.querySelector('.mi-tallas__boton');
    lista.hidden = false;
    caja.classList.add('esta-abierta');
    boton.setAttribute('aria-expanded', 'true');
    abierto = caja;
    /* Hacia arriba si abajo no cabe dentro del panel con scroll del buscador. */
    var cont = caja.closest('.mi-buscador__panel') || document.documentElement;
    var limite = cont.getBoundingClientRect();
    var r = boton.getBoundingClientRect();
    var alto = lista.offsetHeight;
    var abajo = Math.min(limite.bottom, window.innerHeight) - r.bottom;
    var arriba = r.top - Math.max(limite.top, 0);
    if (abajo < alto + 8 && arriba > abajo) { caja.classList.add('hacia-arriba'); }
    var sel = lista.querySelector('[aria-selected="true"]') || lista.querySelector('.mi-tallas__op:not(:disabled)');
    if (sel) { try { sel.focus({ preventScroll: true }); } catch (e) { sel.focus(); } }
  }

  function elegir(caja, op) {
    var fila = caja.closest('[data-mi-fila]');
    var vs = caja._miVariantes || [];
    var v = vs.filter(function (x) { return String(x.id) === op.getAttribute('data-vid'); })[0];
    if (!v) { return; }
    [].slice.call(caja.querySelectorAll('.mi-tallas__op')).forEach(function (o) {
      o.setAttribute('aria-selected', o === op ? 'true' : 'false');
    });
    var boton = caja.querySelector('.mi-tallas__boton');
    boton.setAttribute('data-vid', String(v.id));
    boton.querySelector('.mi-tallas__actual').textContent = nombre(v);
    precioEn(fila, v);
    cerrarLista(true);
  }

  /* #98f (3-nov): SIN BRINCO. Juan: «tiene como un lag para cargar los
     tamaños y como un brinco». Medido: cada fila cambiaba de alto 4–6 veces
     durante 1,2–2,3 s, porque el desplegable aparecía cuando llegaban los
     datos. Ahora la caja del tamaño se pone EN EL MISMO INSTANTE en que nace
     la fila (gris, «Elegir tamaño») y luego solo cambia su texto: el alto de
     la fila no se mueve. Con una sola presentación la caja queda fija con el
     tamaño (sin flecha) en vez de desaparecer. */
  function preparar(fila) {
    if (fila.hasAttribute('data-mi-tallas')) { return; }
    fila.setAttribute('data-mi-tallas', '');
    if (!fila.querySelector('[data-mi-buscador-anadir]')) { return; } // agotado: sin bolsa
    var handle = fila.getAttribute('data-mi-handle');
    if (!handle || fila.querySelector('.mi-buscador__tallas')) { return; }
    var nomFila = fila.getAttribute('data-mi-nombre') || '';

    var caja = document.createElement('div');
    caja.className = 'mi-buscador__tallas';
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'mi-tallas__boton esta-pendiente';
    boton.disabled = true;
    boton.setAttribute('data-mi-talla-buscador', '');
    boton.setAttribute('aria-label', 'Elegir tamaño — ' + nomFila);
    var actual = document.createElement('span');
    actual.className = 'mi-tallas__actual';
    actual.textContent = 'Elegir tamaño';
    boton.appendChild(actual);
    boton.appendChild(icono('M1 1.5l5 5 5-5', '0 0 12 8'));
    caja.appendChild(boton);
    fila.appendChild(caja);
    fila.classList.add('tiene-tallas');

    datosDe(handle).then(function (p) {
      boton.classList.remove('esta-pendiente');
      if (!p || !p.variants) {
        boton.classList.add('es-unica');
        actual.textContent = 'Ver tamaños en la ficha';
        return;
      }
      var vs = p.variants.filter(function (v) { return v && v.id; });
      var libres = vs.filter(function (v) { return v.available; });
      var elegida = libres[0] || vs[0];
      if (!elegida) { return; }
      boton.setAttribute('data-vid', String(elegida.id));
      actual.textContent = nombre(elegida); // el precio ya va encima, en grande
      precioEn(fila, elegida);
      if (libres.length < 2) {
        // Una sola presentación: caja fija, sin lista.
        boton.classList.add('es-unica');
        return;
      }
      var nomProd = p.title || nomFila;
      caja._miVariantes = vs;
      boton.disabled = false;
      boton.setAttribute('aria-haspopup', 'listbox');
      boton.setAttribute('aria-expanded', 'false');
      boton.setAttribute('aria-label', 'Elegir tamaño — ' + nomProd);

      var lista = document.createElement('ul');
      lista.className = 'mi-tallas__lista';
      lista.setAttribute('role', 'listbox');
      lista.setAttribute('aria-label', 'Tamaños de ' + nomProd);
      lista.hidden = true;
      vs.forEach(function (v) {
        var li = document.createElement('li');
        var op = document.createElement('button');
        op.type = 'button';
        op.className = 'mi-tallas__op';
        op.setAttribute('role', 'option');
        op.setAttribute('data-vid', String(v.id));
        op.setAttribute('aria-selected', v === elegida ? 'true' : 'false');
        op.disabled = !v.available;
        op.appendChild(icono('M2.5 7.5l3 3 6-7', '0 0 14 14', 'mi-tallas__check'));
        var n = document.createElement('span');
        n.className = 'mi-tallas__nombre';
        n.textContent = nombre(v);
        var pr = document.createElement('span');
        pr.className = 'mi-tallas__precio';
        pr.textContent = v.available ? dinero(v.price / 100) : 'Agotado';
        op.appendChild(n);
        op.appendChild(pr);
        li.appendChild(op);
        lista.appendChild(li);
      });
      caja.appendChild(lista);
    });
  }

  /* ---- Añadir sin cerrar el buscador (#98d) ------------------------------ */
  var ultimo = null;          // { boton, texto } del último añadido pedido
  var carritoPendiente = false;
  var avisados = 0;

  function buscadorAbierto() {
    var b = document.getElementById('mi-buscador');
    return !!(b && b.classList.contains('esta-abierto'));
  }

  /* Envuelve una sola vez 'ajaxCart.load(respuesta, abrir, deshacer)' del tema:
     con el buscador abierto repinta el carrito SIN abrirlo. */
  function envolverCarrito() {
    var ac = window.ajaxCart;
    if (!ac || !ac.load || ac.load.__miBuscador) { return; }
    var original = ac.load;
    var envuelta = function (resp, abrir, deshacer) {
      if (buscadorAbierto()) {
        carritoPendiente = true;
        var r = original.call(this, resp, false, deshacer);
        exito();
        return r;
      }
      return original.apply(this, arguments);
    };
    envuelta.__miBuscador = true;
    ac.load = envuelta;
    /* mi-product-card.js abre el cajón ANTES de la petición (apertura
       optimista). Si el añadido viene del buscador abierto, se omite. */
    if (ac.open && !ac.open.__miBuscador) {
      var abrirOriginal = ac.open;
      var abrirEnvuelta = function () {
        if (ultimo && buscadorAbierto()) { return; }
        return abrirOriginal.apply(this, arguments);
      };
      abrirEnvuelta.__miBuscador = true;
      ac.open = abrirEnvuelta;
    }
  }

  function exito() {
    if (!ultimo) { return; }
    var boton = ultimo.boton, texto = ultimo.texto;
    ultimo = null;
    if (boton) {
      if (!boton.querySelector('.mi-tallas__ok')) { boton.appendChild(icono('M3 9.5l4 4 8-9', '0 0 18 18', 'mi-tallas__ok')); }
      boton.classList.add('mi-anadido');
      clearTimeout(boton.__miOk);
      boton.__miOk = setTimeout(function () { boton.classList.remove('mi-anadido'); }, 1800);
    }
    avisar(texto);
  }

  function avisar(texto) {
    var panel = document.querySelector('#mi-buscador .mi-buscador__panel');
    if (!panel) { return; }
    var a = panel.querySelector('.mi-tallas-aviso');
    if (!a) {
      a = document.createElement('div');
      a.className = 'mi-tallas-aviso';
      a.setAttribute('role', 'status');
      a.setAttribute('aria-live', 'polite');
      a.appendChild(icono('M3 9.5l4 4 8-9', '0 0 18 18'));
      var t = document.createElement('div');
      t.className = 'mi-tallas-aviso__texto';
      var st = document.createElement('strong');
      var sp = document.createElement('span');
      t.appendChild(st);
      t.appendChild(sp);
      a.appendChild(t);
      var ver = document.createElement('button');
      ver.type = 'button';
      ver.className = 'mi-tallas-aviso__ver';
      ver.textContent = 'Ver carrito';
      a.appendChild(ver);
      panel.appendChild(a);
    }
    avisados += 1;
    a.querySelector('strong').textContent = avisados > 1 ? avisados + ' productos añadidos al carrito' : 'Añadido al carrito';
    a.querySelector('span').textContent = texto || '';
    panel.classList.add('mi-con-aviso');
    requestAnimationFrame(function () { a.classList.add('esta-visible'); });
  }

  function quitarAviso() {
    avisados = 0;
    var panel = document.querySelector('#mi-buscador .mi-buscador__panel');
    if (!panel) { return; }
    panel.classList.remove('mi-con-aviso');
    var a = panel.querySelector('.mi-tallas-aviso');
    if (a) { a.classList.remove('esta-visible'); }
  }

  function anadir(vid, boton, fila) {
    envolverCarrito();
    var sel = fila.querySelector('[data-mi-talla-buscador]');
    var tam = sel ? (sel.querySelector('.mi-tallas__actual') || sel).textContent.trim() : '';
    var nom = fila.getAttribute('data-mi-nombre') || '';
    ultimo = { boton: boton, texto: nom + (tam ? ' · ' + tam : '') };
    window.miCarrito.anadirVariante(vid, boton);
  }

  function revisar(raizNodo) {
    var filas = (raizNodo || document).querySelectorAll('#mi-buscador [data-mi-fila]:not([data-mi-tallas])');
    for (var i = 0; i < filas.length; i++) { preparar(filas[i]); }
  }

  /* ---- Clics, en CAPTURA desde 'document' (antes que mi-search.js) -------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }

    var op = e.target.closest('#mi-buscador .mi-tallas__op');
    if (op) {
      e.preventDefault();
      e.stopPropagation();
      if (!op.disabled) { elegir(op.closest('.mi-buscador__tallas'), op); }
      return;
    }

    var disp = e.target.closest('#mi-buscador .mi-tallas__boton');
    if (disp) {
      e.preventDefault();
      e.stopPropagation();
      var caja = disp.closest('.mi-buscador__tallas');
      if (abierto === caja) { cerrarLista(true); } else { abrirLista(caja); }
      return;
    }

    var ver = e.target.closest('#mi-buscador .mi-tallas-aviso__ver');
    if (ver) {
      e.preventDefault();
      e.stopPropagation();
      var x = document.querySelector('#mi-buscador [data-mi-cerrar]');
      if (x) { x.click(); }
      return;
    }

    // Cualquier otro clic cierra la lista abierta.
    if (abierto && !e.target.closest('.mi-buscador__tallas')) { cerrarLista(false); }

    /* La bolsa: añade la presentación elegida. */
    var boton = e.target.closest('#mi-buscador [data-mi-buscador-anadir]');
    if (!boton) { return; }
    var fila = boton.closest('[data-mi-fila]');
    var handle = fila && fila.getAttribute('data-mi-handle');
    if (!handle || !window.miCarrito || !window.miCarrito.anadirVariante) { return; }
    e.preventDefault();
    e.stopPropagation();
    if (boton.dataset.miEnVuelo === '1') { return; }

    var sel = fila.querySelector('[data-mi-talla-buscador]');
    if (sel && sel.getAttribute('data-vid')) { anadir(sel.getAttribute('data-vid'), boton, fila); return; }

    // Aún sin datos (clic muy rápido) o una sola presentación: se piden y se
    // añade la primera disponible, la misma que enseña el precio de la fila.
    boton.classList.add('esta-cargando');
    datosDe(handle).then(function (p) {
      boton.classList.remove('esta-cargando');
      var vs = p && p.variants ? p.variants.filter(function (v) { return v && v.id; }) : [];
      var v = vs.filter(function (x) { return x.available; })[0];
      if (!v) { window.location.href = raiz + 'products/' + handle; return; }
      var s2 = fila.querySelector('[data-mi-talla-buscador]');
      anadir(s2 && s2.getAttribute('data-vid') ? s2.getAttribute('data-vid') : v.id, boton, fila);
    });
  }, true);

  /* Teclado con la lista abierta: Escape cierra SOLO la lista (no el buscador),
     flechas recorren opciones. En 'window' y en captura para ir antes que el
     manejador de teclas de mi-search.js. */
  window.addEventListener('keydown', function (e) {
    if (!abierto) { return; }
    var ops = [].slice.call(abierto.querySelectorAll('.mi-tallas__op:not(:disabled)'));
    var i = ops.indexOf(document.activeElement);
    if (e.key === 'Escape') {
      e.preventDefault(); e.stopPropagation(); cerrarLista(true);
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); e.stopPropagation();
      var j = e.key === 'ArrowDown' ? Math.min(ops.length - 1, i + 1) : Math.max(0, i - 1);
      if (ops[j]) { ops[j].focus(); }
    } else if (e.key === 'Tab') {
      cerrarLista(false);
    }
  }, true);

  function arrancar() {
    estilos();
    var b = document.getElementById('mi-buscador');
    if (!b) { return; }
    revisar(b);
    /* Sin esperar al siguiente fotograma: el observador corre antes de que el
       navegador pinte, así la fila nueva ya nace con su caja de tamaño (con
       requestAnimationFrame se alcanzaba a ver un fotograma sin ella). */
    new MutationObserver(function () { revisar(b); }).observe(b, { childList: true, subtree: true });
    // Al cerrarse el buscador, se cierra también la lista.
    /* Al cerrarse el buscador: se cierra la lista y, si se añadió algo, se
       abre el carrito (ya repintado) cuando el buscador termina de salir. */
    document.addEventListener('mi:buscador:cerrado', function () {
      cerrarLista(false);
      quitarAviso();
      if (!carritoPendiente) { return; }
      carritoPendiente = false;
      setTimeout(function () {
        if (buscadorAbierto()) { return; }
        if (window.ajaxCart && window.ajaxCart.open) { window.ajaxCart.open(); }
      }, 340);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
